import _ from 'lodash';

const moment = require('moment');

const passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/;

export default async function validate(
  target,
  value,
  error,
  state,
  initialState,
  emailAlreadyExists = false
) {
  const errors = _.cloneDeep(error);
  /* eslint-disable */
  const emailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
  /* eslint-enable */

  function isEmpty() {
    // checking to see if the user clicks in the input field then out right away
    // value will never be empty because we are setting it upon the page loading
    if (value === initialState) {
      return true;
    }
    // if value is empty or contains only whitespace, it's invalid
    return !!(
      value === '' ||
      value === undefined ||
      value.replace(/\s/g, '').length === 0
    );
  }

  // check first and last name
  if (
    target === 'fname' ||
    target === 'lname' ||
    target === 'firstName' ||
    target === 'lastName' ||
    target === 'customSchool' ||
    target === 'activityTitle' ||
    target === 'duration' ||
    target === 'applicationDeadline'
  ) {
    if (isEmpty()) {
      errors[`${target}`] = true;
    } else {
      errors[`${target}`] = false;
    }
  }

  async function emailIsInUse() {
    return emailAlreadyExists !== 'NotFound';
  }

  async function checkEmail() {
    if (isEmpty()) {
      errors.emailEmpty = true;
      errors.emailInvalid = false;
      /* eslint-disable */
      target === 'new-email'
        ? (errors.emailInUse = false)
        : (errors.emailNotInUse = false);
      /* eslint-enable */
    } else if (!emailRegex.test(value)) {
      errors.emailInvalid = true;
      errors.emailEmpty = false;
      /* eslint-disable */
      target === 'new-email'
        ? (errors.emailInUse = false)
        : (errors.emailNotInUse = false);
      /* eslint-enable */
    } else if (await emailIsInUse()) {
      if (target === 'new-email') {
        errors.emailInUse = true;
      } else {
        errors.emailNotInUse = false;
      }

      errors.emailEmpty = false;
      errors.emailInvalid = false;
    } else if (!(await emailIsInUse())) {
      if (target === 'new-email') {
        errors.emailInUse = false;
      } else {
        errors.emailNotInUse = true;
      }

      errors.emailEmpty = false;
      errors.emailInvalid = false;
    } else {
      errors.emailEmpty = false;
      errors.emailInvalid = false;
      errors.emailInUse = false;
    }
  }

  // check email validity
  if (target === 'new-email' || target === 'email') {
    await checkEmail();
  }

  // check birthdate validity
  if (target === 'dob' || target === 'dateOfBirth') {
    const dob = moment(value, 'MM-DD-YYYY');
    const dobRegexPattern =
      /(0\d{1}|1[0-2])\/([0-2]\d{1}|3[0-1])\/(19|20)(\d{2})/;
    const isDOBRegexVerified = dob._i.match(dobRegexPattern);
    if (
      (isEmpty() ||
        moment().diff(dob, 'days') < 0 ||
        !dob.isValid() ||
        !isDOBRegexVerified) &&
      target === 'dob'
    ) {
      errors.dob = true;
    } else {
      errors.dob = false;
    }
    if (
      (isEmpty() ||
        moment().diff(dob, 'days') < 0 ||
        !dob.isValid() ||
        !isDOBRegexVerified) &&
      target === 'dateOfBirth'
    ) {
      errors.dateOfBirth = true;
    } else {
      errors.dateOfBirth = false;
    }
  }

  // check password validity
  if (target === 'password') {
    if (passwordRegex.test(value)) {
      errors[`${target}`] = false;
    } else {
      errors[`${target}`] = true;
    }
    if (state.password !== state.confirmPass && state.confirmPass.length > 0) {
      errors.confirmPass = true;
    } else {
      errors.confirmPass = false;
    }
  }

  // check that passwords entered matched eachother
  if (target === 'confirmPass') {
    if (value === state.password) {
      errors[`${target}`] = false;
    } else {
      errors[`${target}`] = true;
    }
  }

  return errors;
}

export { passwordRegex };
